import { useMemo } from 'react';

import usePathParamCourseProgressSelection from '@/data/hook/course-progress/usePathParamCourseProgressSelection';
import useSearchParamCourseProgressSelection from '@/data/hook/course-progress/useSearchParamCourseProgressSelection';
import useStudentDashboardCourseProgresses, {
  CourseProgressSelection,
} from '@/data/hook/student-dashboard/useStudentDashboardCourseProgresses';

type UseAppShellCourseProgressParams = {
  studentId?: number;
};

export default function useAppShellCourseProgress({
  studentId,
}: UseAppShellCourseProgressParams) {
  const pathSelection = usePathParamCourseProgressSelection();
  const searchSelection = useSearchParamCourseProgressSelection();

  const selection = useMemo<CourseProgressSelection>(
    () => ({
      slug: pathSelection.slug ?? searchSelection.slug,
      fallbackToFirst: true,
      select: searchSelection.select,
    }),
    [pathSelection, searchSelection],
  );

  const { activeCourseProgress, isLoading } =
    useStudentDashboardCourseProgresses({ studentId, selection });

  return { activeCourseProgress, isLoading };
}
